import { render, staticRenderFns } from "./LanguageSwitcher.vue?vue&type=template&id=35dfeeb8&scoped=true&"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js&"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSwitcher.vue?vue&type=style&index=0&id=35dfeeb8&scoped=true&lang=scss&"
import style1 from "./LanguageSwitcher.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dfeeb8",
  null
  
)

export default component.exports